import script from "./PreFixtureDoubleMarket.vue?vue&type=script&setup=true&lang=js"
export * from "./PreFixtureDoubleMarket.vue?vue&type=script&setup=true&lang=js"

import "./PreFixtureDoubleMarket.vue?vue&type=style&index=0&id=8121cb06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8121cb06"]])

export default __exports__